import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_ALL_MEMBER_PLANS = `${API_URL}/playerPlans/getAllPlayerPlans`;
const MEMBER_PLAN_URL = `${API_URL}/playerPlans`;
const GET_ALL_AGENT_PLANS = `${API_URL}/agentPlans/getAllAgentPlans`;
const AGENT_PLAN_URL = `${API_URL}/agentPlans`;
const GET_ALL_CLUB_PLANS = `${API_URL}/clubPlans/getAllClubPlans`;
const CLUB_PLAN_URL = `${API_URL}/clubPlans`;
const GET_ALL_SCOUT_PLANS = `${API_URL}/scoutPlans/getAllScoutPlans`;
const SCOUT_PLAN_URL = `${API_URL}/scoutPlans`;


export const getMemberPlans = createAsyncThunk(
  "getMemberPlans",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_MEMBER_PLANS}?page=${page}&limit=${limit}&search=${search}&all=true`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateMemberPlanDetails = createAsyncThunk(
  "updateMemberPlanDetails",
  async ({ values, id, page }: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${MEMBER_PLAN_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getMemberPlans({ page: page || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addMemberPlanDetails = createAsyncThunk(
  "addMemberPlanDetails",
  async ({ values, page }: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${MEMBER_PLAN_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getMemberPlans({ page: page || 1, limit: 10, all: true }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteMemberPlan = createAsyncThunk(
  "deleteMemberPlan",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.delete(`${MEMBER_PLAN_URL}/${values.id}`);
      notify(data.responseMessage, 'success');
      dispatch(getMemberPlans({ page: values.selectedPage || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const getAgentPlans = createAsyncThunk(
  "getAgentPlans",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_AGENT_PLANS}?page=${page}&limit=${limit}&search=${search}&all=true`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateAgentPlanDetails = createAsyncThunk(
  "updateAgentPlanDetails",
  async ({ values, id, page }: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${AGENT_PLAN_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getAgentPlans({ page: page || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addAgentPlanDetails = createAsyncThunk(
  "addAgentPlanDetails",
  async ({ values, page }: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${AGENT_PLAN_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getAgentPlans({ page: page || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAgentPlan = createAsyncThunk(
  "deleteAgentPlan",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.delete(`${AGENT_PLAN_URL}/${values.id}`);
      notify(data.responseMessage, 'success');
      dispatch(getAgentPlans({ page: values.selectedPage || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

//  Club / Academy Plans
export const getClubPlans = createAsyncThunk(
  "getClubPlans",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_CLUB_PLANS}?page=${page}&limit=${limit}&search=${search}&all=true`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addClubPlanDetails = createAsyncThunk(
  "addClubPlanDetails",
  async ({ values, page }: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${CLUB_PLAN_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getClubPlans({ page: page || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateClubPlanDetails = createAsyncThunk(
  "updateClubPlanDetails",
  async ({ values, id, page }: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${CLUB_PLAN_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getClubPlans({ page: page || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteClubPlan = createAsyncThunk(
  "deleteClubPlan",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.delete(`${CLUB_PLAN_URL}/${values.id}`);
      notify(data.responseMessage, 'success');
      dispatch(getClubPlans({ page: values.selectedPage || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);


//  Club Scout Plans
export const getScoutPlans = createAsyncThunk(
  "getScoutPlans",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_SCOUT_PLANS}?page=${page}&limit=${limit}&search=${search}&all=true`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addScoutPlanDetails = createAsyncThunk(
  "addScoutPlanDetails",
  async ({ values, page }: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${SCOUT_PLAN_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getScoutPlans({ page: page || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateScoutPlanDetails = createAsyncThunk(
  "updateScoutPlanDetails",
  async ({ values, id, page }: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${SCOUT_PLAN_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getScoutPlans({ page: page || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteScoutPlan = createAsyncThunk(
  "deleteScoutPlan",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.delete(`${SCOUT_PLAN_URL}/${values.id}`);
      notify(data.responseMessage, 'success');
      dispatch(getScoutPlans({ page: values.selectedPage || 1, limit: 10, all: true }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);